import { Modal, type ModalHandle } from "ui";
import { FormInput, FormItem } from "ui/form";
import { useButtonTranslate } from "utils/hooks/useTranslate";
import { Button, Form, Select, Space } from "antd";
import { useRef } from "react";

export const CreateButton = () => {
  const modalRef = useRef<ModalHandle>(null);
  const butttonTtranslate = useButtonTranslate();
  const [form] = Form.useForm();

  const footer = (
    <Space>
      <Button onClick={modalRef.current?.close}>
        {butttonTtranslate("cancel")}
      </Button>
      <Button type="primary" onClick={form.submit}>
        发送邀请
      </Button>
    </Space>
  );
  return (
    <>
      <Button type="primary" onClick={modalRef.current?.open}>
        添加物业管理员
      </Button>
      <Modal ref={modalRef} title="添加物业管理员" footer={footer}>
        <Form form={form} labelCol={{ span: 4 }}>
          <FormItem label="邮箱地址" name="email" rules={[{ required: true }]}>
            <Select mode="tags" />
          </FormItem>
        </Form>
      </Modal>
    </>
  );
};
